module.exports = __webpack_public_path__ + "fonts/Roboto-Medium.987ab51.ttf";